import type { QueryKey } from "@tanstack/react-query";

const key = (base: string) => ({
  all: [base] as const,
  lists: (...args: QueryKey) => [base, "list", ...args] as const,
  detail: (...args: QueryKey) => [base, "detail", ...args] as const,
});

// ─────────────────────────────────────────────
// ENTITIES
// ─────────────────────────────────────────────

export const usersKeys = {
  ...key("users"),
  profile: () => ["users", "profile"] as const,
};

export const clientsKeys = key("clients");

export const transactionsKeys = key("transactions");

export const auditLogsKeys = key("audit-logs");

export const chargesKeys = key("charges");

export const preferencesKeys = key("preferences");

// ─────────────────────────────────────────────
// STATS (invalidated on any transaction mutation)
// ─────────────────────────────────────────────

export const statsKeys = {
  all: ["stats"] as const,
  clientsOverview: () => ["stats", "clients-overview"] as const,
  charges: () => ["stats", "charges"] as const,
  transactions: () => ["stats", "transactions"] as const,
  summary: (...args: QueryKey) => ["stats", "summary", ...args] as const,
  users: (id: string) => ["stats", "users", id] as const,
  clients: (id: string) => ["stats", "clients", id] as const,
};
